<kendo-dialog-titlebar kendo-dialog-title>
  <div translate>AoT.CreateTemplate</div>
</kendo-dialog-titlebar>
<form [formGroup]="templateForm">
  <section class="edit-section">
    <div style="height: calc(100% - 80px); display: contents">
      <kendo-formfield class="k-w-full">
        <kendo-label class="min-width-dropdown">{{ 'AoT.TemplateName' | translate }}</kendo-label>
        <kendo-textbox formControlName="templateName" class="k-w-full"></kendo-textbox>
      </kendo-formfield>
    </div>
  </section>
  <section class="edit-section">
    <div class="checkbox">
      <kendo-checkbox formControlName="isPublic" #uncheckedState></kendo-checkbox>
      <kendo-label
        class="k-checkbox-label"
        [for]="uncheckedState"
        text="{{ 'AoT.IsPublic' | translate }}"
      ></kendo-label>
    </div>
  </section>

  <kendo-dialog-actions layout="end">
    <button kendoButton themeColor="error" type="button" (click)="close()">
      {{ 'App.Close' | translate }}
    </button>
    <button kendoButton themeColor="primary" type="button" (click)="save()" class="float-right">
      {{ 'App.Submit' | translate }}
    </button>
  </kendo-dialog-actions>
</form>
